<div class="ratings" [class.selected]="stars() >= 1 && stars() <= 4">
    <!-- Gapless @for: v1 ng-repeat appends the <a> clones adjacently (no text nodes), and these
         are inline-block — with preserveWhitespaces:true any whitespace in the block paints ~4px. -->
    @for (value of values; track value) {<a
            class="rating rating-{{ value - 1 }}"
            [class.selected]="stars() == value"
            (click)="rate(value)"
            (mouseenter)="setCaption(value)"
            (mouseleave)="setCaption()"
            ><span></span></a>}
    <div class="rating-caption"><span [class.ng-hide]="!caption()">"{{ caption() }}"</span></div>
</div>
